import React, { useState } from 'react';
import './homeheroSection.css';
import { 
  FaPlane, 
  FaHotel, 
  FaHome, 
  FaUmbrellaBeach, 
  FaTrain, 
  FaBus, 
  FaCar, 
  FaMoneyBill, 
  FaShieldAlt 
} from 'react-icons/fa';

const HomeheroSection = () => {
  const [tripType, setTripType] = useState('One Way');
  const [travelers, setTravelers] = useState(1);
  const [fareType, setFareType] = useState('Regular');
  const [classType, setClassType] = useState('Economy/Premium Economy');

  const handleTripTypeChange = (type) => {
    setTripType(type);
  };

  const handleTravelersChange = (count) => {
    setTravelers(count);
  };

  const handleFareTypeChange = (type) => {
    setFareType(type);
  };

  const handleClassChange = (type) => {
    setClassType(type);
  };

  return (
    <div className="Fhero-section">
      <div className="nav-icons">
        <FaPlane className="icon active" />
        <FaHotel className="icon" />
        <FaHome className="icon" />
        <FaUmbrellaBeach className="icon" />
        <FaTrain className="icon" />
        <FaBus className="icon" />
        <FaCar className="icon" />
        <FaMoneyBill className="icon" />
        <FaShieldAlt className="icon" />
      </div>
      <div className="booking-container">
        <div className="trip-type">
          <button 
            className={tripType === 'One Way' ? 'active' : ''} 
            onClick={() => handleTripTypeChange('One Way')}
          >
            One Way
          </button>
          <button 
            className={tripType === 'Round Trip' ? 'active' : ''} 
            onClick={() => handleTripTypeChange('Round Trip')}
          >
            Round Trip
          </button>
          <button 
            className={tripType === 'Multi City' ? 'active' : ''} 
            onClick={() => handleTripTypeChange('Multi City')}
          >
            Multi City
          </button>
        </div>
        <div className="flight-details">
          <div className="location">
            <label>From</label>
            <input type="text" defaultValue="Delhi, DEL, Delhi Airport India" />
          </div>
          <div className="swap-icon">↔</div>
          <div className="location">
            <label>To</label>
            <input type="text" defaultValue="Bengaluru, BLR, Bengaluru International Airport..." />
          </div>
          <div className="date">
            <label>Departure</label>
            <input type="date" defaultValue="2025-02-24" />
            <span>Monday</span>
          </div>
          {tripType === 'Round Trip' && (
            <div className="date">
              <label>Return</label>
              <input type="date" placeholder="Tap to add return date for bigger discounts" />
            </div>
          )}
          <div className="travelers-class">
            <label>Travellers & Class</label>
            <select value={travelers} onChange={(e) => handleTravelersChange(e.target.value)}>
              <option value="1">1 Traveller</option>
              <option value="2">2 Travellers</option>
              <option value="3">3 Travellers</option>
            </select>
            <select value={classType} onChange={(e) => handleClassChange(e.target.value)}>
              <option value="Economy/Premium Economy">Economy/Premium Economy</option>
              <option value="Business">Business</option>
              <option value="First Class">First Class</option>
            </select>
          </div>
        </div>
        <div className="fare-type">
          <label>Select a special fare</label>
          <button 
            className={fareType === 'Regular' ? 'active' : ''} 
            onClick={() => handleFareTypeChange('Regular')}
          >
            Regular
          </button>
          <button 
            className={fareType === 'Student' ? 'active' : ''} 
            onClick={() => handleFareTypeChange('Student')}
          >
            Student
          </button>
          <button 
            className={fareType === 'Senior Citizen' ? 'active' : ''} 
            onClick={() => handleFareTypeChange('Senior Citizen')}
          >
            Senior Citizen
          </button>
          <button 
            className={fareType === 'Armed Forces' ? 'active' : ''} 
            onClick={() => handleFareTypeChange('Armed Forces')}
          >
            Armed Forces
          </button>
          <button 
            className={fareType === 'Doctor and Nurses' ? 'active' : ''} 
            onClick={() => handleFareTypeChange('Doctor and Nurses')}
          >
            Doctor and Nurses
          </button>
        </div>
        <button className="search-button">SEARCH</button>
      </div>
      <div className="footer-links">
        <span>Where2Go</span>
        <span>Insurance for International Trips</span>
        <span>Explore International Flights</span>
        <span>MICE, Events & Meetings</span>
        <span>Gift Cards</span>
      </div>
    </div>
  );
};

export default HomeheroSection;